// Scrollbar grid fix.
function updateGridViewportWidth() {
	let width = '100vw';
	const documentBodyElement = document.body;
	if (documentBodyElement) {
		const documentBodyElementWidth = documentBodyElement.offsetWidth;
		if (typeof documentBodyElementWidth === 'number') {
			width = documentBodyElementWidth.toString() + 'px';
		}
		documentBodyElement.style.setProperty("--grid-viewport-width", width);
	}
};
window.addEventListener('resize', updateGridViewportWidth);
document.addEventListener('DOMContentLoaded', updateGridViewportWidth);

document.addEventListener('DOMContentLoaded', function (e) {
	const cookieButtons = document.querySelectorAll('.cli-bar-btn_container a[role="button"]');

	if (cookieButtons.length) {
		cookieButtons.forEach(function (element) {
			element.setAttribute('tabindex', '0');
		});
	}
});